import { FIELDS } from "@nineteen-2/dtc-din";

const getFieldsFromFieldGroup = (field, except) => {
  return [
    FIELDS.SKIER_HEIGHT,
    FIELDS.SKIER_WEIGHT,
    FIELDS.SKIER_SOLE_LENGTH,
    FIELDS.SKIER_TYPE,
    FIELDS.RECOMMENDED,
    FIELDS.SELECTED
  ]
    .filter((fieldName) => !except || !except.includes(fieldName))
    .reduce((acc, fieldName) => {
    acc[fieldName] = field.fieldGroup.find(f => f.key === field.key + '_' + fieldName)
    return acc
  }, {})
}

export {
  getFieldsFromFieldGroup
}